import React, { useMemo, useState } from "react";
import { CanEdit, useIsReadOnlyManager } from "@/shared/readOnlyManager";
import {
  useExpanded,
  usePagination,
  useResizeColumns,
  useSortBy,
  useTable,
} from "react-table";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import { Button, Col, Row, Table } from "reactstrap";
import { TABLE_COLUMNS } from "./columns";
import { connect, useDispatch } from "react-redux";
import {
  reducer,
  useEffectToDispatch,
  fetchApiData,
  initialState,
} from "@/shared/apiTableHelper";
import AddEditScheduledReportsModal from "./AddEditScheduledReportsModal";
import { Link } from "react-router-dom";
import PencilIcon from "mdi-react/PencilIcon";
import TrashCanIcon from "mdi-react/TrashCanIcon";
import { flashError, flashSuccess } from "@/shared/components/flash";
import axios from "axios";
// import ScheduledAwardSummaryFilter from "./ScheduledAwardSummaryFilter";

const queryClient = new QueryClient();

const DataTable = ({ organization, program }) => {
  const readOnly = useIsReadOnlyManager();
  const [filter, setFilter] = useState({
    // programs: programs,
    // programs: [],
    // onlyPending: false,
    // programId: program.id,
    // from: dateStrToYmd(getFirstDay()),
    // to: dateStrToYmd(new Date()),
  });
  const [useFilter, setUseFilter] = useState(false);
  const [trigger, setTrigger] = useState(0);
  const [isScheduledReportOpen, setScheduledReportOpen] = useState(false);
  const [editData, setEditData] = useState('')
  const dispatchAction = useDispatch()


  const [
    {
      queryPageIndex,
      queryPageSize,
      totalCount,
      queryPageFilter,
      queryPageSortBy,
      queryTrigger,
    },
    dispatch,
  ] = React.useReducer(reducer, initialState);

  const apiUrl = `/organization/${organization.id}/program/${program.id}/scheduledreport`;
  const { isLoading, error, data, isSuccess } = useQuery(
    [
      "",
      apiUrl,
      queryPageIndex,
      queryPageSize,
      queryPageFilter,
      queryPageSortBy,
      queryTrigger,
    ],
    () =>
      fetchApiData({
        url: apiUrl,
        page: queryPageIndex,
        size: queryPageSize,
        filter,
        sortby: queryPageSortBy,
        trigger: queryTrigger,
      }),
    {
      keepPreviousData: true,
      staleTime: Infinity,
    }
  );
  const toggleScheduledReport = () => {
    setScheduledReportOpen(!isScheduledReportOpen)
    setEditData('');
  }
  const onClickEditEvent = (data) => {
    toggleScheduledReport();
    setEditData(data)
  };

  const onDeleteEvent = (e, id) => {
    axios.delete(`/organization/${organization.id}/program/${program.id}/scheduledreport/${id}`)
      .then((res) => {
        if (res.status == 200) {
          flashSuccess(dispatchAction, "Scheduled Reoprt was deleted!");
          setTrigger(Math.floor(Date.now() / 1000))
        }
      })
      .catch((err) => {
        flashError(dispatchAction, err.response.data);
      });
  };

  const RenderActions = ({ row }) => {
    return (
      <span className="d-inline-block" >
        <Link to={{}} onClick={() => onClickEditEvent(row.original)}>
          <PencilIcon style={{ marginRight: "0.5rem" }} />
          Edit
        </Link>
        <span style={{ width: "2.5rem", display: "inline-block" }}></span>
        <Link
          to={{}}
          style={{ color: '#FF3930' }}
          onClick={(e) => {
            if (window.confirm("Are you sure to delete this scheduled report?")) {
              onDeleteEvent(e, row.original.id);
            }
          }}
        >
          <TrashCanIcon style={{ marginRight: "0.5rem" }} />
          Delete
        </Link>
      </span>
    );
  };

  let final_columns = [
    ...TABLE_COLUMNS,
    ...(readOnly ? [] : [
      {
        Header: "Action",
        accessor: "action",
        // Footer: "Action",
        Cell: ({ row }) => <RenderActions row={row} />,
      },
    ]),
  ];
  let columns = useMemo(() => final_columns, []);

  const totalPageCount = Math.ceil(totalCount / queryPageSize);

  const {
    getTableProps,
    headerGroups,
    rows,
    prepareRow,
    gotoPage,
    state: { pageIndex, pageSize, sortBy },
  } = useTable(
    {
      columns: columns,
      data: data?.full ? data.full : [],
      initialState: {
        pageIndex: queryPageIndex,
        pageSize: queryPageSize,
        sortBy: queryPageSortBy,
      },
      manualPagination: true,
      pageCount: data ? totalPageCount : null,
      autoResetSortBy: false,
      autoResetExpanded: false,
      autoResetPage: false,
      disableResizing: true,
      autoResetHiddenColumns: false,
      striped: true,
    },
    useSortBy,
    useExpanded,
    usePagination,
    useResizeColumns
  );

  useEffectToDispatch(dispatch, {
    pageIndex,
    pageSize,
    gotoPage,
    sortBy,
    filter,
    data,
    useFilter,
    trigger,
  });

  if (isLoading) {
    return (
      <section className="manager-report-panel manager-report-panel--state">
        Loading scheduled reports...
      </section>
    );
  }

  if (error) {
    return (
      <section className="manager-report-panel manager-report-panel--state">
        Unable to load scheduled reports.
      </section>
    );
  }

  if (isSuccess) {
    return (
      <div className="table react-table report-table">
        <div className="action-panel">
          <Row className="mx-0">
            <Col>
              <div className="text-end">
                <CanEdit>
                  <Button className="btn btn-primary" onClick={toggleScheduledReport}>
                    New Scheduled Report
                  </Button>
                </CanEdit>
              </div>
              <AddEditScheduledReportsModal toggle={toggleScheduledReport} isOpen={isScheduledReportOpen} {...{ editData, setTrigger }} />
            </Col>
          </Row>
        </div>
        {rows.length === 0 ? (
          <div className="manager-report-table__empty">No scheduled reports yet.</div>
        ) : (
          <Table striped borderless size="md" className="table--stack-mobile" {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()}>{column.render("Header")}</th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {rows.map((row, i) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()} data-label={typeof cell.column.Header === 'string' ? cell.column.Header : ''}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        )}
      </div>
    );
  }
};

const TableWrapper = ({ organization, program }) => {
  if (!organization || !program) {
    return (
      <section className="manager-report-panel manager-report-panel--state">
        Loading scheduled reports...
      </section>
    );
  }
  return (
    <QueryClientProvider client={queryClient}>
      <DataTable {...{ organization, program }} />
    </QueryClientProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    program: state.program,
    organization: state.organization,
  };
};
export default connect(mapStateToProps)(TableWrapper);
